/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ min: NonNullable<unknown>, view: NonNullable<unknown> }} Consumption_View_Too_ShortInputs */



/**
* | output |
* | --- |
* | "Period too short for this view ({min} minimum): use the {view} view or lengthen the period." |
*
* @param {Consumption_View_Too_ShortInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const consumption_view_too_short = /** @type {((inputs: Consumption_View_Too_ShortInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumption_View_Too_ShortInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Period too short for this view (${i?.min} minimum): use the ${i?.view} view or lengthen the period.`)
	return /** @type {LocalizedString} */ (`Période trop courte pour cette vue (${i?.min} minimum) : utilisez la vue ${i?.view} ou allongez la période.`)
});